/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetTradingChallengeResultsOptions,
  GetTradingChallengeResultsResponses,
} from '../types/GetTradingChallengeResults'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description List challenge leaderboard/results. Public endpoint.
 * @summary Get trading challenge results
 * {@link /v1/trading_challenges/:trading_challenge_id/results}
 */
export function getTradingChallengeResults<ThrowOnError extends boolean = true>(
  options: Options<GetTradingChallengeResultsOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetTradingChallengeResultsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/trading_challenges/{trading_challenge_id}/results',
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetTradingChallengeResultsResponses, ThrowOnError>>,
  )
}
